export const property = {
  createProperty: {
    title: "Utwórz obiekt",
    of: "z",
  },
  sections: {
    details: "Dane obiektu",
    presentation: "Prezentacja",
    rooms: "Pokoje",
    bookingSettings: "Ustawienia rezerwacji",
    checkinSettings: "Ustawienia check-in",
    extras: "Usługi dodatkowe",
  },

  menu: {
    name: "Nazwa",
    location: "Lokalizacja",
    logo: "Logo obiektu",
    capacity: "Pojemność",
    services: "Usługi obiektu",
    description: "Opis",

    roomTypes: "Typy pokoi",
    roomManagement: "Zarządzaj pokojami",

    imagesRooms: "Zdjęcia pokoi",
    imagesProperty: "Zdjęcia obiektu",

    priceCurrency: "Cena i waluta",
    rates: "Stawki",
    maintenance: "Utrzymanie obiektu",

    scheduling: "Harmonogram",

    sesHospedajes: "SES Hospedajes",

    smartLocks: "Inteligentne zamki",
    experiences: "Atrakcje i usługi",
    chatbot: "ChatBot AI",
  },

  firstStep: {
    heading: "Jak nazywa się Państwa obiekt?",
    subheading:
      "Przyciągnij gości chwytliwą nazwą, która podkreśla to, co najlepsze w Państwa obiekcie.",
    fieldLabel: "Nazwa obiektu",
    placeholder: "np. Rajska Plaża",
    internalNameLabel: "Nazwa wewnętrzna",
    internalNamePlaceholder: "Wewnętrzna nazwa referencyjna obiektu",
  },

  locationStep: {
    heading: "Gdzie znajduje się Państwa obiekt?",
    subheading:
      "Prosimy podać dokładny adres, aby goście łatwo trafili na miejsce.",
    countryLabel: "Kraj",
    addressLabel: "Pełny adres",
    addressPlaceholder: "np. ul. Sierpes 25, Sewilla",
    cityLabel: "Miasto",
    cityPlaceholder: "np. Sewilla",
    zipLabel: "Kod pocztowy",
    zipPlaceholder: "np. 41004",
  },
  logoStep: {
    heading: "Jakie jest logo Państwa obiektu?",
    description:
      "Dodaj logo obiektu, aby wyglądał bardziej profesjonalnie i był łatwiejszy do rozpoznania. Dozwolone formaty: PNG, JPG, SVG.",
    currentLogoTitle: "Obecne logo:",
    currentLogoAlt: "Obecne logo",
  },

  roomTypeStep: {
    heading: "Informacje o pokoju",
    description:
      "Wpisz nazwę dla tego typu pokoju, na przykład „Pokój dwuosobowy” lub „Apartament rodzinny”. Pomoże to łatwo rozpoznać go w kalendarzu i kanałach rezerwacyjnych. Pozostałe typy pokoi można dodać w panelu",
    basicInfoTitle: "Podstawowe informacje",
    nameLabel: "Nazwa",
    namePlaceholder: "Nazwa własna",
    occupancyTitle: "Pojemność pokoju",
    adultsLabel: "Dorośli",
    childrenLabel: "Dzieci",
    infantsLabel: "Niemowlęta",
  },

  hotelRoomsStep: {
    heading: "Przypisz pokoje fizyczne obiektu",
    description:
      "Utwórz rzeczywiste pokoje, które będą dostępne do rezerwacji, na przykład „101 - Pokój dwuosobowy” lub „302 - Apartament rodzinny”. Ułatwi to porządkowanie ich w kalendarzu i zarządzanie dostępnością.",
    roomTypeLabel: "Typ pokoju",
    roomNameLabel: "Nazwa pokoju",
    roomNamePlaceholder: "Nazwa własna",
    roomCodeLabel: "Numer lub kod pokoju",
    roomCodePlaceholder: "Opcjonalnie",
  },

  capacityStep: {
    heading: "Podaj najważniejsze informacje o obiekcie",
    description:
      "Określ liczbę gości, sypialni i łazienek. Domyślnie sypialnie i łazienki są traktowane jako prywatne. Jeśli są współdzielone, można to później zmienić w danych obiektu.",
    labels: {
      guests: "Goście",
      bedrooms: "Sypialnie",
      bathrooms: "Łazienki",
    },
  },

  servicesStep: {
    heading: "Pokaż gościom, co oferuje Państwa obiekt",
    subtitle:
      "Wybierz dostępne udogodnienia. Kolejne można dodać później w CMS.",
    services: {
      oven: "Piekarnik i płyta grzewcza",
      pets_allowed: "Zwierzęta dozwolone",
      wifi: "Internet Wi-Fi",
      essentials: "Podstawowe wyposażenie",
      washing_machine: "Pralka",
      air_conditioning: "Klimatyzacja",
      heating: "Ogrzewanie centralne",
      parking: "Miejsce parkingowe",
      children_allowed: "Dzieci dozwolone",
      refrigerator: "Lodówka",
    },
  },

  priceStep: {
    heading: "Jaka jest cena za noc?",
    subtitle:
      "Ustaw cenę domyślną, aby utworzyć pierwszą stawkę za noc, oraz walutę obiektu.",
    labels: {
      pricePerNight: "Stawka za noc",
      currency: "Waluta",
    },
    placeholders: {
      priceExample: "np. 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "Jak opisaliby Państwo swój obiekt?",
    subtitle:
      "Przyciągnij gości krótkim opisem obiektu. Podkreśl dostępne udogodnienia i ciekawe miejsca w okolicy.",
    placeholders: {
      example:
        "np. Stylowy loft z widokiem na miasto, idealny do pracy, zakupów i chłonięcia miejskiego klimatu.",
    },
    inspiration: "Potrzeba inspiracji?",
    buttons: {
      useAI: "Użyj AI",
      generating: "Generowanie...",
    },
    errors: {
      generate:
        "Wystąpił błąd podczas generowania opisu. Prosimy spróbować ponownie.",
    },
  },
  navigation: {
    save: "Zapisz",
    next: "Dalej",
  },
  common: {
    success: "Gotowe",
    error: "Błąd",
    cancel: "Anuluj",
    save: "Zapisz",
  },

  images: {
    heading: "Zdjęcia obiektu",
    subtitleHotel:
      "Dodaj zdjęcia pokoi, aby mogły zostać użyte na stronie rezerwacji bezpośrednich.",
    subtitleApt:
      "Dodaj zdjęcia obiektu, aby mogły zostać użyte na stronie rezerwacji bezpośrednich.",

    loadRoomsError: "Nie udało się wczytać pokoi",
    uploadSuccess: "Prawidłowe zdjęcia przesłane pomyślnie",
    uploadErrorGeneric: "Błąd przesyłania zdjęć",

    deleteConfirmMessage: "Czy na pewno usunąć to zdjęcie?",
    deleteConfirmHeader: "Potwierdzenie",
    deleteAccept: "Usuń",
    deleteReject: "Anuluj",
    deleteSuccess: "Zdjęcie usunięte pomyślnie",
    deleteError: "Błąd usuwania zdjęcia",

    setMainSuccess: "Zdjęcie główne zaktualizowane",
    setMainError: "Błąd ustawiania zdjęcia głównego",

    invalidFilesTitle: "Nieprawidłowe pliki",

    mainBadge: "Główne",
  },

  dropzone: {
    prompt: "Przeciągnij zdjęcia tutaj lub kliknij, aby wybrać",
    formatHint: "Formaty: JPEG, PNG, GIF.",
    uploading: "Przesyłanie zdjęć... {progress}%",
    invalidHeader: "Niektóre pliki nie spełniają wymagań:",
    reasonType: "nieprawidłowy typ",
    reasonSize: "przekracza limit rozmiaru",
    and: "oraz",
  },

  checkin: {
    heading: "Kiedy będą wysyłane linki do check-in?",
    subtitle:
      "Zaplanuj automatyczne wysyłanie linku do check-in Państwa gościom.",

    options: {
      same_day: { amount: "Tego samego dnia", text: "co check-in" },
      24: { amount: "24 godziny", text: "przed check-inem" },
      48: { amount: "48 godzin", text: "przed check-inem" },
      72: { amount: "72 godziny", text: "przed check-inem" },
      disabled: { amount: "Wyłącz", text: "wyślę go ręcznie" },
    },
    recommended: "Zalecane",

    details: {
      sameDay: "6:00 tego samego dnia",
      previousNight: "18:00 poprzedniego wieczoru",
      corresponding: "18:00 odpowiedniego dnia",
    },

    confirm: {
      message: "Czy na pewno zmienić harmonogram check-in?",
      header: "Potwierdź zmianę",
      accept: "Zmień harmonogram",
      reject: "Anuluj",
    },

    toasts: {
      loadError: {
        title: "Błąd",
        body: "Nie udało się wczytać ustawień check-in.",
      },
      saveSuccess: {
        title: "Ustawienia zaktualizowane",
        body: "Proces zakończony pomyślnie",
      },
    },

    messages: {
      disabled: "Automatyczne wysyłanie jest wyłączone. Trzeba wysłać ręcznie.",
      same_day: "Check-iny będą wysyłane o 6:00 tego samego dnia co check-in",
      exactly24: "Check-iny będą wysyłane o 18:00 wieczorem przed check-inem",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "Check-iny będą wysyłane o 18:00, {days} dni przed check-inem",
    },
  },

  police: {
    header: "Zarejestruj dane właściwego organu",
    toasts: {
      saveSuccess: {
        title: "Operacja zakończona pomyślnie",
        body: "Dane organu zostały zapisane pomyślnie",
      },
    },
    errors: {
      lessorRequired: {
        title: "Błąd, pole wynajmującego",
        body: "Kod wynajmującego jest wymagany",
      },
      establishmentRequired: {
        title: "Błąd, pole obiektu",
        body: "Kod obiektu jest wymagany",
      },
    },
  },

  identity: {
    title: "Sklep przy zameldowaniu",
    subtitle: "Przy zameldowaniu gość dostaje na WhatsAppie link z tym, co może dodać do pobytu.",
    propertyLabel: "Obiekt:",
    toggle: {
      title: "Włącz weryfikację tożsamości",
      hint: "Po włączeniu goście będą musieli zweryfikować swoją tożsamość.",
      on: "WŁ.",
      off: "WYŁ.",
    },
    toasts: {
      updated: "Ustawienia weryfikacji tożsamości zaktualizowane pomyślnie",
      updateError: "Błąd aktualizacji ustawień weryfikacji tożsamości",
    },
  },

  guestReviews: {
    subtitle:
      "Wpisz URL serwisu z opiniami, który chcą Państwo skonfigurować, aby goście mogli zostawić swoją opinię w Google lub innym używanym serwisie. Pomaga to poprawić widoczność i reputację obiektu.",
    enableTitle: "Włącz opinie gości",
  },

  smartLocks: {
    title: "Inteligentne zamki",
    subtitle:
      "Połącz się ze zgodnymi inteligentnymi zamkami i zapomnij o fizycznych kluczach. Generuj i wysyłaj kody dostępu automatycznie, bez pracy ręcznej i w 100% bezpiecznie.",
    propertyLabel: "Obiekt",
    compatibleTitle: "Zgodne inteligentne zamki",
    andManyMore: "i wiele innych...",

    enableTitle: "Włącz inteligentny zamek",
    enableHelp:
      "Wyślij gościom kod dostępu po ukończeniu check-in, dokładnie o wybranej godzinie check-in.",

    configTitle: "Konfiguracja",
    configSubtitle: "Ustaw preferencje wysyłki kodu dostępu",

    deliveryLabel: "Godzina wysłania kodu dostępu",
    deliveryDesc:
      "Wybierz godzinę, o której kod dostępu zostanie wysłany gościowi w dniu jego rezerwacji.",
    saveTimeBtn: "Zapisz godzinę",
    saveTimeLoading: "Zapisywanie...",

    accessTypeLabel: "Rodzaj kodu dostępu",

    static: {
      title: "Kod statyczny",
      desc: "Ten sam kod dla wszystkich gości",
    },
    dynamic: {
      title: "Kod dynamiczny",
      desc: "Generuj unikalne kody dla każdej rezerwacji",
      soon: "Wkrótce",
    },

    masterCodeLabel: "Główny kod dostępu",
    masterCodePlaceholder: "Wpisz swój główny kod dostępu",
    saveCodeBtn: "Zapisz kod",
    saveCodeLoading: "Zapisywanie...",

    masterCodeHelp:
      "Ten kod zostanie wysłany gościom automatycznie o wskazanej godzinie w dniu ich check-in.",

    dynamicInfo: {
      title: "Dynamiczne kody dostępu",
      desc: "Ta funkcja premium będzie automatycznie generować unikalne kody dostępu dla każdej rezerwacji, zapewniając większe bezpieczeństwo i lepsze wrażenia gości. Już wkrótce!",
    },

    support: {
      title: "Potrzebna pomoc z integracją?",
      desc: "Integrujemy się ze wszystkimi głównymi markami inteligentnych zamków. Nasz zespół techniczny pomoże skonfigurować Państwa model.",
      cta: "Skontaktuj się z pomocą",
    },

    errors: {
      emptyKey: "Prosimy wpisać klucz dostępu",
    },

    toasts: {
      updateSuccess: "Ustawienia inteligentnego zamka zaktualizowane pomyślnie",
      updateError: "Błąd aktualizacji ustawień inteligentnego zamka",
      timeSuccess: "Godzina wysyłki zaktualizowana pomyślnie",
      timeError: "Błąd aktualizacji godziny wysyłki",
      keySuccess: "Klucz dostępu zapisany pomyślnie",
      keyError: "Błąd zapisywania klucza dostępu",
    },
  },

  services: {
    listMovedHelp: "Lista usług jest jedna dla całego konta: wpisujesz ją raz i zaznaczasz, w których ofertach jest dostępna.",
    listMovedLink: "Przejdź do Usługi i atrakcje",
    title: "Atrakcje i usługi",
    subtitle: "Zarządzaj usługami dodatkowymi swojego obiektu.",
    enableTitle: "Włącz sklep z atrakcjami i usługami",
    enableHelp:
      "Promuj wszystkie dodatkowe atrakcje i usługi swojego obiektu. Goście otrzymują link na WhatsApp przy check-inie.",
    storeType: {
      title: "Rodzaj sklepu",
      internal: {
        title: "Sklep wewnętrzny",
        desc: "Zarządzaj usługami bezpośrednio na platformie",
      },
      external: {
        title: "Sklep zewnętrzny",
        desc: "Przekieruj gości do swojego sklepu zewnętrznego",
      },
    },
    externalConfig: {
      title: "Konfiguracja sklepu zewnętrznego",
      guestMessageLabel: "Wiadomość dla gości",
      guestMessagePlaceholder:
        "Np.: Odkryj nasze usługi dodatkowe i wyjątkowe atrakcje w naszym sklepie internetowym...",
      guestMessageHelp:
        "Wiadomość pokazywana gościom po check-inie (maks. 200 znaków)",
      urlLabel: "URL Państwa sklepu zewnętrznego",
      urlPlaceholder: "https://twoj-sklep-zewnetrzny.com",
      urlHelp: "Pełny URL, pod którym goście mogą rezerwować atrakcje i usługi",
      noteTitle: "Uwaga:",
      noteText:
        "Goście otrzymają tę spersonalizowaną wiadomość z linkiem po ukończeniu check-in.",
    },
    addBtn: "Dodaj",
    delete: {
      title: "Usunąć usługę?",
      text: "Tej operacji nie można cofnąć",
      confirm: "Usuń",
      cancel: "Anuluj",
    },
    toasts: {
      stateUpdated: "Status usługi zaktualizowany",
      deleted: "Usługa usunięta pomyślnie",
      storeUpdated: "Ustawienia atrakcji i usług zaktualizowane pomyślnie",
      storeError: "Błąd aktualizacji ustawień atrakcji i usług",
      configUpdated: "Konfiguracja sklepu zaktualizowana pomyślnie",
      configError: "Błąd aktualizacji konfiguracji sklepu",
    },
  },
  bot: {
    enableTitle: "Włącz wirtualnego asystenta",
    enableHelp: "Zautomatyzuj obsługę gości dzięki szybkim odpowiedziom na WhatsApp.",
  },

  rooms: {
    heading: "Typy pokoi",
    subtitle: "Zarządzaj typami pokoi swojego obiektu.",
    addTypeCta: "Dodaj typ pokoju",
    adultsCapacity: "Pojemność dla dorosłych: {count}",
    emptyList: "Brak zarejestrowanych pokoi.",

    deleteConfirmHeader: "Potwierdź usunięcie",
    deleteConfirmMessage:
      "Czy na pewno usunąć ten pokój? Tej operacji nie można cofnąć.",
    deleteConfirmAccept: "Tak, usuń",
    deleteConfirmReject: "Anuluj",

    deleteSuccess: "Pokój usunięty pomyślnie.",
    deleteError: "Błąd usuwania pokoju.",
  },

  roomMgmt: {
    remaining: "Dostępne: {count}",
    heading: "Zarządzaj pokojami",
    subtitle: "Przypisz pojedyncze pokoje do zarejestrowanych typów.",
    totalRooms: "Pokoje łącznie: {count}",

    typeLabel: "Typ",
    codeLabel: "Kod",
    nameLabel: "Nazwa",
    descLabel: "Opis",

    selectPlaceholder: "Wybierz",
    codePlaceholder: "Kod",
    namePlaceholder: "Nazwa pokoju",
    descPlaceholder: "Opis pokoju",

    addBtn: "Dodaj",

    planLimitTitle: "Osiągnięto limit",
    planLimitMsg:
      "Osiągnęli Państwo maksymalną liczbę pokoi dozwoloną w swoim planie. Prosimy podnieść subskrypcję, aby dodać więcej.",

    loadTypesError: "Nie udało się wczytać typów pokoi",
    loadRoomsError: "Nie udało się wczytać istniejących pokoi",

    saveSuccessTitle: "Gotowe",
    saveSuccessMsg: "Pokoje zapisane pomyślnie",
    saveError: "Nie udało się zapisać pokoi",

    deleteSuccess: "Pokój usunięty pomyślnie.",
    deleteError: "Błąd usuwania pokoju.",
    formIncompleteError:
      "Prosimy uzupełnić typ i nazwę dla wszystkich pokoi.",
  },

  rates: {
    heading: "Stawki",
    subtitleHotel: "Zarządzaj stawkami swoich obiektów.",
    subtitleSingle: "Zarządzaj stawkami swojego obiektu.",
    adultsCapacity: "Pojemność dla dorosłych: {count}",
    roomsCount: "Pokoje {count}",
    singleUnit: "Jednostka obiektu",

    table: {
      name: "Nazwa",
      occupancy: "Goście",
      priceTaxIncl: "Cena (Z PODATKIEM)",
      actions: "Akcje",
    },

    addRate: "Dodaj stawkę",
    emptyList: "Brak zarejestrowanych stawek.",

    deleteConfirmHeader: "Potwierdź usunięcie",
    deleteConfirmMessage:
      "Czy na pewno usunąć tę stawkę? Tej operacji nie można cofnąć.",
    deleteConfirmAccept: "Tak, usuń",
    deleteConfirmReject: "Anuluj",

    deleteSuccess: "Stawka usunięta pomyślnie.",
    deleteError: "Błąd usuwania stawki.",
  },
};

export default property;
